import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Loading } from '@ibk/shared-ui';
export const ccPaths = {
    base: '/contabilidade-digital',
    documents: '/contabilidade-digital/documentos',
    documentsCND: '/contabilidade-digital/documentos/cnd',
    documentsViewer: '/contabilidade-digital/documentos/visualizar',
    generalRequests: '/contabilidade-digital/solicitacoes-gerais',
    generalRequestsEmployeeRegistration: '/contabilidade-digital/solicitacoes-gerais/cadastro-empregados',
    generalRequestsTaxpayersRegistration: '/contabilidade-digital/solicitacoes-gerais/cadastro-contribuintes',
    generalRequestsInternsRegistration: '/contabilidade-digital/solicitacoes-gerais/cadastro-estagiarios',
    generalRequestsVacationNotice: '/contabilidade-digital/solicitacoes-gerais/aviso-previo-ferias',
    generalRequestsVacationCalculation: '/contabilidade-digital/solicitacoes-gerais/calculo-ferias',
    generalRequestsTerminationNotice: '/contabilidade-digital/solicitacoes-gerais/aviso-previo-rescisao',
    generalRequestsTerminationCalculation: '/contabilidade-digital/solicitacoes-gerais/calculo-rescisao',
    generalRequestsEmployeeLeave: '/contabilidade-digital/solicitacoes-gerais/afastamento-empregado',
    generalRequestsEarningsEntries: '/contabilidade-digital/solicitacoes-gerais/lancamento-rubricas',
    invoiceProcessing: '/contabilidade-digital/manifestacao-nfe',
    boxe: '/contabilidade-digital/box-e',
    reports: '/contabilidade-digital/relatorios',
    reportsPublishedDocuments: '/contabilidade-digital/relatorios/documentos-publicados',
    reportsPayrollEntries: '/contabilidade-digital/relatorios/lancamento-rubricas',
    reportsEmployeeRegistration: '/contabilidade-digital/relatorios/cadastro-empregados',
};
const RenderClientCenterApplication = React.lazy(async () => {
    try {
        const clientCenterApp = await import('clientcenter/App');
        return clientCenterApp;
    }
    catch (err) {
        console.error('[ClientCenter] remote failed to load:', err);
        return { default: () => _jsx("div", { style: { padding: 24 }, children: "Client Center temporariamente indispon\u00EDvel." }) };
    }
});
export default function ClientCenterRouter() {
    return (_jsx(React.Suspense, { fallback: _jsx(Loading, { fullScreen: true }), children: _jsx(RenderClientCenterApplication, {}) }));
}
